import React, { useMemo } from "react";
import styles from "../styles/platos.module.css";
import ConfirmDeleteModal from "../../../components/ConfirmDeleteModal";
import { showSuccessToast } from "../../../components/toast/toastBus";

import { usePlatosData } from "../hooks/usePlatosData";
import { usePlatosUI } from "../hooks/usePlatosUI";
import { usePlatoForm } from "../hooks/usePlatoForm";

import { filterAndSortPlatos } from "../domain/platosFilters";
import { platosApi } from "../api/platosApi";

import PlatosFiltersBar from "../components/PlatosFiltersBar";
import PlatosList from "../components/PlatoList";
import PlatoModal from "../components/PlatoModal";

export default function Platos() {
  const { platos, alergenos, loading, error, reload } = usePlatosData();
  const ui = usePlatosUI();
  const form = usePlatoForm();

  const list = useMemo(() => filterAndSortPlatos(platos, ui.q), [platos, ui.q]);

  const requestDelete = (id) => {
    ui.setDeleteId(id);
    ui.setShowConfirm(true);
  };

  const confirmDelete = async () => {
    if (!ui.deleteId) return;
    try {
      await platosApi.remove(ui.deleteId);
      await reload();
    } catch (e) {
      console.error(e);
      alert("Error al eliminar el plato.");
    } finally {
      ui.setShowConfirm(false);
      ui.setDeleteId(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const esEdicion = !!form.editingPlato;
      if (esEdicion) {
        await platosApi.update({ id: form.editingPlato.id, ...form.formData });
      } else {
        await platosApi.create(form.formData);
      }
      form.close();
      form.reset();
      await reload();
      showSuccessToast(esEdicion ? "Plato actualizado con éxito" : "Plato creado con éxito");
    } catch (e2) {
      console.error(e2);
      alert("Error al guardar plato.");
    }
  };

  if (loading) {
    return (
      <div className={styles.page}>
        <div className={`${styles.wrap} ${styles.stack}`}>
          <div className={styles.titlebar}><h2>Platos</h2></div>
          <div className={`${styles.card} ${styles.soft}`}>Cargando…</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.page}>
        <div className={`${styles.wrap} ${styles.stack}`}>
          <div className={styles.titlebar}><h2>Platos</h2></div>
          <div className={`${styles.card} ${styles.warn}`}>
            <strong>Error:</strong> {error}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={`${styles.wrap} ${styles.stack}`}>
        <div className={styles.titlebar}>
          <h2>Platos</h2>
        </div>

        <PlatosFiltersBar
          q={ui.q}
          onQ={ui.setQ}
          onCreate={form.openCreate}
        />

        <PlatosList
          list={list}
          isOpen={ui.isPlatoOpen}
          onToggle={ui.togglePlato}
          onEdit={form.openEdit}
          onDelete={requestDelete}
        />
      </div>

      <PlatoModal
        open={form.formVisible}
        editing={!!form.editingPlato}
        formData={form.formData}
        setFormData={form.setFormData}
        alergenos={alergenos}
        onClose={() => {
          form.close();
          form.reset();
        }}
        onSubmit={handleSubmit}
      />

      {ui.showConfirm && (
        <ConfirmDeleteModal
          title="Confirmar eliminación"
          message="El plato será eliminado de la carta y no podrá asignarse a eventos."
          confirmWord="Eliminar"
          onClose={() => {
            ui.setShowConfirm(false);
            ui.setDeleteId(null);
          }}
          onConfirm={confirmDelete}
        />
      )}
    </div>
  );
}
